import type { TouchEvent } from 'react';
import { clamp } from '@CS/utils/Number';
import { Screen } from '@CS/app/App.styles';
import { useState, useEffect, useRef } from 'react';

import {
  WeekButton,
  BUTTON_WIDTH
} from '@CS/components/Popups/Leaderboard/weeks';

import { WeeksContainer, SCROLL_DURATION } from './LeaderBoardWeeks.styles';

type LeaderBoardWeeksProps = {
  onClick: (index: number) => void;
  current?: number;
  weeks: number;
};

export const LeaderBoardWeeks = ({
  weeks,
  onClick,
  current = 0
}: LeaderBoardWeeksProps) => {
  const [end, setEnd] = useState(0);
  const [start, setStart] = useState(0);

  const [offset, setOffset] = useState(0);
  const [position, setPosition] = useState(0);

  const container = useRef<HTMLElement>(null);
  const [animate, setAnimate] = useState(false);

  const [selected, setSelected] = useState(current);
  const [scrollable, setScrollable] = useState(false);

  const weeksWidth =
    Math.min(window.innerWidth, +Screen.MAX.slice(0.0, -2.0)) * 0.9 -
    Math.min(window.innerHeight * 0.035, 25.0) * 2.0;

  const origin = (weeksWidth - BUTTON_WIDTH) * 0.5;

  const onTouchStart = (event: TouchEvent) =>
    setStart(event.changedTouches[0].clientX);

  const onTouchMove = (event: TouchEvent) => {
    if (!scrollable) return;
    const { clientX } = event.changedTouches[0];
    setPosition(clamp(clientX - start + end, offset, origin));
  };

  const onTouchEnd = () => setEnd(position);

  const onButtonClick = (index: number) => {
    setTimeout(() => setAnimate(false), SCROLL_DURATION);
    scrollable && setSelectedButton(index);

    setAnimate(scrollable);
    setSelected(index);
    onClick(index);
  };

  const setSelectedButton = (index: number) => {
    const position = index * (BUTTON_WIDTH + 5);
    setPosition(origin - position);
    setEnd(origin - position);
  };

  useEffect(() => {
    const width = container.current?.offsetWidth ?? 0;
    const scrollable = width > weeksWidth;

    scrollable && setSelectedButton(selected);
    setOffset(weeksWidth - width - origin);
    setScrollable(scrollable);
  }, []);

  return (
    <WeeksContainer
      style={{ transform: `translateX(${position}px)` }}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      $animate={animate}
      ref={container}
    >
      {[...Array(weeks)].map((_, w) => (
        <WeekButton
          selected={selected === w}
          onClick={onButtonClick}
          index={w}
          key={w}
        />
      ))}
    </WeeksContainer>
  );
};
